"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SickLeaveVerifyDoctorRequestBody_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SickLeaveDoctorDetails_1 = require("./SickLeaveDoctorDetails");
var SickLeaveVerifyDoctorRequestBody_Factory = /** @class */ (function () {
    function SickLeaveVerifyDoctorRequestBody_Factory() {
    }
    SickLeaveVerifyDoctorRequestBody_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Data: SickLeaveDoctorDetails_1.SickLeaveDoctorDetails_Factory.CreateIncoming(model.Data),
            IssuerDoB: model.IssuerDoB,
            IssuerNationalId: model.IssuerNationalId,
            OrganizationId: model.OrganizationId,
        };
        return result;
    };
    SickLeaveVerifyDoctorRequestBody_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Data: SickLeaveDoctorDetails_1.SickLeaveDoctorDetails_Factory.CreateOutgoing(model.Data),
            IssuerDoB: model.IssuerDoB,
            IssuerNationalId: model.IssuerNationalId,
            OrganizationId: model.OrganizationId,
        };
        return result;
    };
    return SickLeaveVerifyDoctorRequestBody_Factory;
}());
exports.SickLeaveVerifyDoctorRequestBody_Factory = SickLeaveVerifyDoctorRequestBody_Factory;
